import React from "react";
import { makeStyles } from "@fluentui/react-components";
import { BuildingHomeFilled, BuildingHomeRegular } from "@fluentui/react-icons";
import PropTypes from "prop-types";
import { useComboboxStyles } from "../styles/comboboxStyles";

const useStyles = makeStyles({
  optionContent: {
    display: "flex",
    alignItems: "start",
    gap: "8px",
  },
  icon: {
    width: "20px",
    height: "20px",
  },
});

export const PropertyOption = ({ text, selectedValue }) => {
  const styles = useStyles();
  const comboboxStyles = useComboboxStyles();
  return (
    <div className={styles.optionContent}>
      {selectedValue !== text ? (
        <>
          <BuildingHomeRegular className={styles.icon} />
          <span className={comboboxStyles.optionText}>{text}</span>
        </>
      ) : (
        <>
          <BuildingHomeFilled className={styles.icon} />
          <span className={comboboxStyles.optionText}>
            <strong>{text}</strong>
          </span>
        </>
      )}
    </div>
  );
};

PropertyOption.propTypes = {
  text: PropTypes.string,
  selectedValue: PropTypes.string,
};
